import { useEffect, useState } from 'react';
import { supabase } from "../../../supabase";
import styles from './Stadium24Message.module.css';

export default function Stadium24Message() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    fetchMessages();
  }, []);

  useEffect(() => {
    document.body.style.backgroundColor = 'var(--gray-900)';

    return () => {
      document.body.style.backgroundColor = '';
    };
  }, []);

  const fetchMessages = async () => {
    try {
      const { data, error } = await supabase
        .from('stadium24_message')
        .select(`
          message,
          stadium24 (
            name
          )
        `);

      if (error) throw error;
      setMessages(data);
    } catch (error) {
      console.error('메시지를 불러오는 중 에러가 발생했습니다:', error);
    }
  };

  return (
    <div className={styles.container}>
        <div className={styles.header}>

        <h1 className={styles.title}>서플라이팀 2024년 수고하셨습니다! ❤️</h1>
        <p className={styles.description}>스타디움24에서 구장주님들이 남겨주신 메시지입니다.</p>
        </div>
      
      <div className={styles.grid}>
        {messages.map((item, index) => (
          <div key={index} className={styles.card}>
            <p className={styles.message}>{item.message}</p>
            <h5 className={styles.stadiumName}>{item.stadium24.name}</h5>
          </div>
        ))}
      </div>
    </div>
  );
}